<template>
<div>
    <AppLoader v-if="isLoading" class="text-center" small />

    <b-row class="pri-row">
        <b-col cols="12">
            <h1 class="my-5">Create PRI</h1>

            <b-col>
                <b-button size="sm" variant="outline-warning" class="float-right mr-2" @click="addNewIndicator">
                    <font-awesome-icon icon="plus" /> Add new indicator
                </b-button>

                <b-tabs>

                   
                    <b-tab title="Score">

                        <b-table-simple class="table">
                            <b-thead>
                                <b-tr>
                                    <b-th scope="col">Risk</b-th>
                                    <b-th scope="col">From</b-th>
                                    <b-th scope="col">To</b-th>
                                </b-tr>
                            </b-thead>

                            <b-tbody>

                                <b-tr>
                                    <b-th>Low</b-th>
                                    <b-td>1</b-td>
                                    <b-td>
                                        <b-input onkeydown="return event.keyCode !== 69" type="number" v-model="leastValue" @input="setScore"></b-input>
                                    </b-td>
                                </b-tr>

                                <b-tr>
                                    <b-th>Medium</b-th>
                                    <b-td>{{parseInt(leastValue) + 1 }} </b-td>
                                    <b-td>
                                        <b-input onkeydown="return event.keyCode !== 69" type="number" :min="parseInt(leastValue) + 2" v-model="mediumValue" @input="setScore"></b-input>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th>High</b-th>
                                    <b-td>{{parseInt(mediumValue) + 1}}</b-td>
                                    <b-td>100<br />

                                        <label class="text-danger">{{showScoreError}}</label>

                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>

                    </b-tab>

                    <b-tab title="Weighting">
                        <b-row>
                            <b-col class="ml-4">
                                <b-row v-for="(defaultIndicator, index) in defaultIndicators" :key="index">

                                    <b-col>
                                        <b-form-group id="fieldset-1" label-cols-sm="4" label-cols-lg="3" :label="defaultIndicator.text" label-for="input-1" class="text-left mt-3">
                                            <b-form-input onkeydown="return event.keyCode !== 69" :disabled="!disableValues[defaultIndicator.key]" id="input-1" type="number" min="1" max="100" @input="onUpdateSumValues" v-model="defaultIndicator.value"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="1">
                                        <b-form-checkbox class="mt-3" v-model="disableValues[defaultIndicator.key]" @change="onDisableValue($event, index)">
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>

                                <!-- <b-form-group id="fieldset-1" label-cols-sm="4" label-cols-lg="3" label="Country" label-for="input-1" class="text-left">
                                        <b-form-input id="input-1" type="number" min="1" max="100" v-model="countryValue" @input="onUpdateSumValues"></b-form-input>
                                    </b-form-group>

                                    <b-form-group id="fieldset-1" label-cols-sm="4" label-cols-lg="3" label="Industry" label-for="input-1" class="text-left">
                                        <b-form-input id="input-1" type="number" min="1" max="100" v-model="industryValue" @input="onUpdateSumValues"></b-form-input>
                                    </b-form-group> -->

                                <b-row v-for="(indicator,index) in indicators" :key="indicator.indicatorTitle">
                                    <b-col>
                                        <b-form-group label-cols-sm="4" label-cols-lg="3" :label="indicator.indicatorTitle" class="text-left">
                                            <b-form-input onkeydown="return event.keyCode !== 69" type="number" :disabled="!indicator.show" min="1" max="100" v-model="indicator.indicatorValue" @input="onUpdateSumValues"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="1">
                                        <b-form-checkbox class="mt-2" v-model="indicator.show" @change="onDisableDynamicValue($event, index)">
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>

                                <b-form-group :invalid-feedback="showSumError" id="fieldset-1" label-cols-sm="4" label-cols-lg="3" label="Total" class="text-left mr-5">
                                    <b-form-input id="input-1" :state="showSumError ? false : null" type="number" :value="totalSum" readonly=""></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-tab>

                    <b-tab title="Negative Media">
                        <b-card style="height:calc(100vh - 275px); overflow-y:auto;">
                            <h4 class="text-left">Advanced filters</h4>
                            <div class="text-left">
                                <b-form-checkbox v-model="sort" value="1">Order by latest</b-form-checkbox>
                                <b-form-checkbox v-model="exactTerms" value="1">Exact Phrase Match</b-form-checkbox>
                                <b-form-group label="Index from">
                                    <b-form-select v-model="selectedStart" :options="numberOfGoogleResults"></b-form-select>
                                </b-form-group>
                            </div>
                            <b-row>
                                <b-col cols="6">
                                    <h4 class="mt-3 text-left">Keyword search and phrases</h4>
                                    <b-input-group class="mt-3">
                                        <b-form-input placeholder="Enter the entity name you would like to search..." @keyup.enter="addAdditionalKeywordPhrases()" v-model="name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button @click="addAdditionalKeywordPhrases" variant="outline-warning">Add</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <b-form-checkbox-group class="text-left mt-3" :options="keywords" stacked v-model="selectedKeywords"></b-form-checkbox-group>
                                </b-col>
                                <b-col cols="6">
                                    <h4 class="mt-3 text-left">Exclude Keyword search and phrases</h4>
                                    <b-input-group class="mt-3">
                                        <b-form-input placeholder="Enter the entity name you would like to search..." @keyup.enter="addAdditionalExcludeKeywordPhrases()" v-model="excludeTerm"></b-form-input>
                                        <b-input-group-append>
                                            <b-button @click="addAdditionalExcludeKeywordPhrases" variant="outline-warning">Add</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <b-form-checkbox-group class="text-left mt-3" :options="excludeTerms" stacked v-model="selectedExcludeTerms"></b-form-checkbox-group>
                                </b-col>
                                <b-col cols="6">
                                    <h4 class="mt-3 text-left">Language</h4>
                                    <b-form-radio-group class="text-left mt-3" :options="languageOptions" stacked v-model="selectedLanguage"></b-form-radio-group>
                                </b-col>

                            </b-row>
                        </b-card>
                    </b-tab>

                    <b-tab title="Country">
                        <b-col style="height:calc(100vh - 325px); overflow-y:auto;">
                            <b-form-group v-for="(country,index) in optionsCountries" :key="index" :id="'fieldset'+index" label-cols-sm="4" label-cols-lg="9" :label="country.name" label-for="input-1" class="text-left">
                                <b-form-input type="number" min="1" max="100" value=""></b-form-input>
                            </b-form-group>
                        </b-col>

                    </b-tab>
                    <b-tab title="Industry">

                    </b-tab>
                    <b-tab v-for="(indicator,index) in indicators" :key="'dyn-tab-' + index" :title="indicators[index].indicatorTitle">
                        <b-card style="height:calc(100vh - 475px); overflow-y:auto;">
                            <b-button size="sm" class="float-left" variant="outline-warning" @click="addNewIndicatorOption(index)">
                                <font-awesome-icon icon="plus" /> Add new indicator option
                            </b-button>

                            <b-table :items="indicators[index].indicatorOptions" :fields="indicators[index].fields">
                                <template v-slot:cell(text)="data">

                                    <b-form-input :v-model="indicatorOptText" @input="updateIndicstorText($event, data.index, index, indicator)"></b-form-input>

                                </template>
                                <template v-slot:cell(value)="data">

                                    <b-form-input type="number" min="1" max="100" :v-model="indicatorOptValue" @input="updateIndicstorValue($event, data.index, index, indicator)"></b-form-input>

                                </template>

                            </b-table>
                        </b-card>

                    </b-tab>
                     <b-tab title="Rules">
                        <b-col cols="12" class="mr-0">

                            <div>
                                <b-row>
                                    <table class="table table-sm">
                                        <thead>
                                            <tr class="text-center">
                                                <th>No</th>
                                                <th>When</th>
                                                <th>Conditions</th>
                                                <th>Has Value</th>
                                                <th>
                                                    <b-button size="sm" @click="addMoreRules">Add Rule</b-button>
                                                </th>
                                                <!-- <th>Actions</th> -->
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(rule, index) in selectionRules" :key="rule.id">
                                                <td>{{index}}</td>
                                                <td>
                                                    <b-form-input disabled :value="rule.label" />
                                                </td>
                                                <td>
                                                    <b-form-input disabled :value="rule.value" />
                                                </td>
                                                <td>
                                                    <!-- <b-button
                              variant="outline-danger"
                              class="btn-sm ml-1"
                              @click="onRemoveConditionOpt(selectedOpt.id, index)"
                            >
                              <i class="fa fa-trash"></i>
                            </b-button> -->
                                                </td>
                                            </tr>

                                            <tr v-for="(rule, index) in noORules" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>
                                                    <v-select :v-model="ruleField" class="mb-2" :options="availableIndicators" label="text" @input="getSelectedIndicatorValues"></v-select>
                                                </td>
                                                <td>
                                                    <v-select :v-model="customCondition" class="mb-2" :options="setOfConditions" label="text" @input="onSelectCondition"></v-select>
                                                </td>
                                                <td>
                                                    <v-select class="mb-2" :v-model="conditionalRuleValue" label="value" :options="selectedIndicatorOption"></v-select>
                                                </td>
                                                <td>
                                                    <b-button size="sm" @click="removeRules(index)">Remove</b-button>
                                                </td>

                                                <!-- <td>
                            <b-button
                              class="btn-sm"
                              variant="outline-primary"
                              @click="setRules"
                            >Apply</b-button>
                          </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <b-button variant="primary" @click="addConditionsNumber">
                      <i class="fa fa-plus"></i>
                    </b-button>-->
                                </b-row>
                            </div>
                        </b-col>
                    </b-tab>
                </b-tabs>

            </b-col>
        </b-col>

        <b-alert v-model="showErrorToast" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="danger" dismissible solid>Error</b-alert>

        <b-modal id="modal-1" title="Add new indicator" v-model="showIndicatorModal" @ok="createIndicator" ok-title="Create">
            <b-form-group label-cols-sm="4" label-cols-lg="3" label="Indicator Name" label-for="input-1" class="text-left">
                <b-form-input type="text" v-model="indicatorTitle" trim></b-form-input>
            </b-form-group>
        </b-modal>
    </b-row>

</div>
</template>

<script>
import {
    HTTP
} from "../utils/HTTP";
import countriesData from "../utils/countryCodes.json";
import AppLoader from "../components/Loader/Loader";
import SearchResult from "../components/negative-media/search-results.vue";
import vSelect from "vue-select";
import _ from "lodash";

export default {
    name: "mediaSearchPage",
    components: {
        vSelect,
        SearchResult,
        AppLoader

    },
    data() {
        return {

            indicatorTitle: null,
            showIndicatorModal: false,
            optionsCountries: countriesData.countries,
            indicators: [],
            tabCounter: 0,
            showErrorToast: false,
            searchEntityNameText: null,
            name: null,
            keywords: [{
                    text: "bribery",
                    value: "bribery"
                },
                {
                    text: "bribed",
                    value: "bribed"
                },
                {
                    text: "bribing",
                    value: "bribing"
                },
                {
                    text: "accused",
                    value: "accused"
                },
                {
                    text: "fined",
                    value: "fined"
                },
                {
                    text: "sanctioned",
                    value: "sanctioned"
                },
                {
                    text: "sanctions",
                    value: "sanctions"
                },
                {
                    text: "enforcement",
                    value: "enforcement"
                },
                {
                    text: "charged",
                    value: "charged"
                },
                {
                    text: "ofac",
                    value: "ofac"
                }
            ],
            excludeTerms: [{
                    text: "kingpin",
                    value: "kingpin"
                },
                {
                    text: "Career",
                    value: "career"
                }
            ],
            excludeTerm: null,
            selectedKeywords: [
                "bribery",
                "bribed",
                "bribing",
                "accused",
                "fined",
                "sanctions",
                "sanctioned",
                "enforcement",
                "charged",
                "ofac"
            ],
            selectedExcludeTerms: ["kingpin", "career"],
            isEditing: false,
            selectedIndex: null,
            totalResults: null,
            items: [],
            isLoading: false,
            sort: 0,
            selectedStart: 1,
            numberOfGoogleResults: [{
                    value: 1,
                    text: "10"
                },
                {
                    value: 2,
                    text: "20"
                },
                {
                    value: 3,
                    text: "30"
                },
                {
                    value: 4,
                    text: "40"
                },
                {
                    value: 5,
                    text: "50"
                },
                {
                    value: 6,
                    text: "60"
                },
                {
                    value: 7,
                    text: "70"
                },
                {
                    value: 8,
                    text: "80"
                },
                {
                    value: 9,
                    text: "90"
                },
                {
                    value: 10,
                    text: "100"
                }
            ],
            exactTerms: 0,
            selectedLanguage: "lang_en",
            languageOptions: [{
                    value: "lang_en",
                    text: "English"
                },
                {
                    value: "lang_ar",
                    text: "Arabic"
                },
                {
                    value: "lang_bg",
                    text: "Bulgarian"
                },
                {
                    value: "lang_ca",
                    text: "Catalan"
                },
                {
                    value: "lang_cs",
                    text: "Czech"
                },
                {
                    value: "lang_hr",
                    text: "Croatian"
                },
                {
                    value: "lang_zh-CN",
                    text: "Chinese (Simplified)"
                },
                {
                    value: "lang_zh-TW",
                    text: "Chinese (Traditional)"
                },
                {
                    value: "lang_da",
                    text: "Danish"
                },
                {
                    value: "lang_nl",
                    text: "Dutch"
                },
                {
                    value: "lang_et",
                    text: "Estonian"
                },
                {
                    value: "lang_fr",
                    text: "French"
                },
                {
                    value: "lang_fi",
                    text: "Finnish"
                },
                {
                    value: "lang_de",
                    text: "German"
                },
                {
                    value: "lang_el",
                    text: "Greek"
                },
                {
                    value: "lang_hu",
                    text: "Hungarian"
                },
                {
                    value: "lang_iw",
                    text: "Hebrew"
                },
                {
                    value: "lang_id",
                    text: "Indonesian"
                },
                {
                    value: "lang_is",
                    text: "Icelandic"
                },
                {
                    value: "lang_it",
                    text: "Italian"
                },
                {
                    value: "lang_ja",
                    text: "Japanese"
                },
                {
                    value: "lang_ko",
                    text: "Korean"
                },
                {
                    value: "lang_lt",
                    text: "Lithuanian"
                },
                {
                    value: "lang_lv",
                    text: "Latvian"
                },
                {
                    value: "lang_no",
                    text: "Norwegian"
                },
                {
                    value: "lang_pl",
                    text: "Polish"
                },
                {
                    value: "lang_pt",
                    text: "Portuguese"
                },
                {
                    value: "lang_ro",
                    text: "Romanian"
                },
                {
                    value: "lang_ru",
                    text: "Russian"
                },
                {
                    value: "lang_sk",
                    text: "Slovak"
                },
                {
                    value: "lang_sl",
                    text: "Slovenian"
                },
                {
                    value: "lang_sr",
                    text: "Serbian"
                },

                {
                    value: "lang_es",
                    text: "Spanish"
                },
                {
                    value: "lang_sv",
                    text: "Swedish"
                },

                {
                    value: "lang_tr",
                    text: "Turkish"
                }
            ],
            indicatorOptText: null,
            indicatorOptValue: null,
            totalSum: null,
            sumValues: [],
            showSumError: null,
            disableValues: {
                negative: true,
                country: true,
                industry: true,
            },
            defaultIndicators: [{
                    text: 'Negative Media',
                    value: 0,
                    key: 'negative'
                },
                {
                    text: 'Country',
                    value: 0,
                    key: 'country'
                },
                {
                    text: 'Industry',
                    value: 0,
                    key: 'industry'
                },
            ],

            // fo score
            leastValue: 1,
            mediumValue: 1,
            highestValue: 100,
            showScoreError: null,
            totalScore: null,

            //for rules
            ruleField: null, // v-model for select 1
            conditionalRuleValue: null, // v-model for select 2
            customCondition: null, // v-model for select 3
            selectionRules: [],
            noORules: [1],
            selectedIndicatorOption: [],
            setOfConditions: [{
                    text: 'Greater than',
                    value: 0,
                },
                {
                    text: 'Less than',
                    value: 0,
                },
                {
                    text: 'Greater than equals to',
                    value: 0,
                },
                {
                    text: 'Less than equals to',
                    value: 0,
                },

            ],
            availableIndicators: [{
                    text: 'Negative Media',
                    value: 0,
                    key: 'negative'
                },
                {
                    text: 'Country',
                    value: 0,
                    key: 'country'
                },
                {
                    text: 'Industry',
                    value: 0,
                    key: 'industry'
                },

            ]

        };
    },
    methods: {
        addNewIndicatorOption(index) {

            this.indicators[index].indicatorOptions.push({
                text: 'option ' + index,
                value: 'option ' + index
            });

        },

        addNewIndicator() {
            this.showIndicatorModal = true;

        },

        createIndicator() {
            this.tabCounter++;
            this.indicators.push({
                indicatorTitle: this.indicatorTitle,
                indicatorValue: 0,
                indicatorOptions: [],
                show: true,
                fields: ['text', 'value']
            });
            let strKey = this.indicatorTitle.replace(/\s/g, ''); // regex to remove all white spaces
            // // console.log("strKey", strKey)
            // this.defaultIndicators.push({text: this.indicatorTitle, value: 0, key: strKey})
            this.availableIndicators.push({
                text: this.indicatorTitle,
                value: 0,
                key: strKey
            })
            // this.disableValues[strKey] = true
            this.indicatorTitle = null;
        },

        getDateFromArticle(article) {
            let snippet = article.snippet;
            let data = snippet.split("...");
            return data[0];
        },

        addAdditionalKeywordPhrases() {
            let set = {
                value: this.name,
                text: this.name
            };
            this.keywords.unshift(set);
            this.selectedKeywords.push(set.value);
            this.name = null;
            // console.log(this.keywords);
        },

        addAdditionalExcludeKeywordPhrases() {
            let set = {
                value: this.excludeTerm,
                text: this.excludeTerm
            };
            this.excludeTerms.unshift(set);
            this.selectedExcludeTerms.push(set.value);
            this.excludeTerm = null;
        },

        removeName(index) {
            this.keywords.splice(index, 1);
        },

        onUpdateSumValues(value, key) {
            // // console.log("------", value)

            // this.fieldData.options[index].value = value;
            this.getSumOfAllValues();
        },

        getSumOfAllValues() {
            // let options = this.fieldData.options;
            let sumOfDefaultIndicatorsValues = _.sumBy(this.defaultIndicators, function (o) {
                return parseInt(o.value) || 0;
            });

            let sumOfIndicatorsValues = _.sumBy(this.indicators, function (o) {
                return parseInt(o.indicatorValue) || 0;
            });

            // indicators[index].indicatorValue
            // let sumOfAllValues = (parseInt(this.negativeValue)  + parseInt(this.countryValue) + parseInt(this.industryValue) + sumOfIndicatorsValues)
            let sumOfAllValues = sumOfDefaultIndicatorsValues + sumOfIndicatorsValues;

            if (sumOfAllValues > 100) {
                this.showSumError = "This value cannot be grater than 100"
            } else {
                this.showSumError = null
                this.totalSum = sumOfAllValues;
            }
        },

        async submitSearch() {
            let token = "Bearer " + localStorage.getItem("accessToken");
            this.items = [];
            try {
                this.isLoading = true;
                let result = await HTTP(
                    "post",
                    "v1/negativemedia/search", {
                        searchEntityNameText: this.searchEntityNameText,
                        keywordPhraseMatch: this.selectedKeywords,
                        exactTerms: this.exactTerms,
                        excludeTerms: this.selectedExcludeTerms,
                        language: this.selectedLanguage,
                        start: this.selectedStart,
                        sort: this.sort,
                        userId: 5163,
                        companyId: 204
                    }, {
                        Authorization: token
                    },
                    null,
                    true
                );
                this.totalResults = result.data.google.searchInformation.totalResults;
                this.items = result.data.google.items || [];
                this.isLoading = false;
                // console.log(result.data);
            } catch {
                this.isLoading = false;
                this.showErrorToast = true;
            }
        },

        updateIndicstorText(e, optIndex, indicatorIndex, indicator) {

            this.indicatorOptText = e;
            let strKey = indicator.indicatorTitle.replace(/\s/g, '');
            this.indicators[indicatorIndex].indicatorOptions[optIndex].text = this.indicatorOptText
            let indexOfIndicator = this.availableIndicators.findIndex(i => i.key == strKey);
            this.availableIndicators[indexOfIndicator].text = this.indicatorOptText

        },

        updateIndicstorValue(e, optIndex, indicatorIndex, indicator) {
            this.indicatorOptValue = e;
            let strKey = indicator.indicatorTitle.replace(/\s/g, '');
            this.indicators[indicatorIndex].indicatorOptions[optIndex].value = this.indicatorOptValue
            let indexOfIndicator = this.availableIndicators.findIndex(i => i.key == strKey);
            this.availableIndicators[indexOfIndicator].value = parseInt(this.indicatorOptValue)

        },

        onDisableValue(e, index) {
            // // console.log("this.disabsjas", e, index)
            if (!e) {
                this.defaultIndicators[index].value = 0
                this.getSumOfAllValues();
            }
        },

        onDisableDynamicValue(e, index) {
            // // console.log("this.disabsjas", e, index, this.indicators) 
            if (!e) {
                this.indicators[index].indicatorValue = 0
                this.getSumOfAllValues();
            }
        },

        //for rules
        setRules() {

        },

        addMoreRules() {
            this.noORules.push(1)

        },
        removeRules(index) {
            // console.log("index", index)
            this.noORules.splice((index), 1)
        },

        getSelectedIndicatorValues(selectedIndicator) {
            // // console.log("getSelectedIndicatorValues", selectedIndicator )
            // // console.log("getSelectedIndicatorValues", selectedIndicator )
            // // console.log("getSelectedIndicatorValues", this.availableIndicators )
            this.selectedIndicatorOption = [];
            this.conditionalRuleValue = null;
            this.selectedIndicatorOption.push(selectedIndicator)

        },

        onSelectCondition(selectedCondition) {
            // console.log("onSelectCondition", selectedCondition)
        },

        //for score
        setScore(e) {
            this.sumScore();

        },

        sumScore() {

            let sumOfAllScores = ((parseInt(this.leastValue) + 1) + (parseInt(this.mediumValue) - 3))
            // // console.log("sumOfAllScores", sumOfAllScores)

            if (sumOfAllScores != 100) {
                this.showScoreError = "Total score must be 100"
            } else {
                this.showScoreError = null
                this.totalScore = sumOfAllScores;
            }

        }
    }
};
</script>

<style scoped>
.pri-row {
    height: calc(100vh - 150px);
    overflow-y: scroll;
}
</style>
